import { useEffect, useState } from 'react';
import { Outlet, ScrollRestoration, useLocation } from 'react-router-dom';
import { Footer } from './Footer';
import { Header } from './Header';
import { StudioSidebar } from './StudioSidebar';

export function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setSidebarOpen(false);
  }, [location.pathname, location.search, location.hash]);

  useEffect(() => {
    document.body.classList.toggle('studio-sidebar-lock', sidebarOpen);
    return () => document.body.classList.remove('studio-sidebar-lock');
  }, [sidebarOpen]);

  return (
    <div className="app-frame app-frame-with-sidebar">
      <ScrollRestoration />
      <Header toolsOpen={sidebarOpen} onToggleTools={() => setSidebarOpen((value) => !value)} />
      <StudioSidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="app-content-with-sidebar">
        <main>
          <Outlet />
        </main>
        <Footer />
      </div>
    </div>
  );
}
